// extracted by mini-css-extract-plugin
export default {"TableLoader":"TableLoaderDark__TableLoader___o4VQc"};